import { Box } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const FormFields = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 32,
  width: '100%',
});

export const FooterActions = styled(Box)({
  display: 'flex',
  gap: 16,
  justifyContent: 'flex-end',
  marginTop: 32,
});

export const PlaceholderBox = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  color: theme.palette.text.secondary,
  display: 'flex',
  justifyContent: 'center',
  minHeight: 200,
}));
